var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bid-left-top" }, [
    _c("div", { staticClass: "place-text" }, [_vm._v("Closes in :")]),
    _vm._v(" "),
    _c("div", { staticClass: "spaceLeft" }, [
      _c("div", { staticClass: "bid-time-min spaceCenter" }, [
        _c("div", { staticClass: "bid-time-text" }, [
          _c("div", { staticClass: "bid-time-text-big" }, [
            _vm._v(_vm._s(_vm.dd)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bid-time-text-sm" }, [_vm._v("DAY")]),
        ]),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "bid-time-spot" }, [_vm._v(":")]),
      _vm._v(" "),
      _c("div", { staticClass: "bid-time-sec spaceCenter" }, [
        _c("div", { staticClass: "bid-time-text" }, [
          _c("div", { staticClass: "bid-time-text-big" }, [
            _vm._v(_vm._s(_vm.PrefixInteger(_vm.hh))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bid-time-text-sm" }, [_vm._v("HOR")]),
        ]),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "bid-time-spot" }, [_vm._v(":")]),
      _vm._v(" "),
      _c("div", { staticClass: "bid-time-sec spaceCenter" }, [
        _c("div", { staticClass: "bid-time-text" }, [
          _c("div", { staticClass: "bid-time-text-big" }, [
            _vm._v(_vm._s(_vm.PrefixInteger(_vm.mm))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bid-time-text-sm" }, [_vm._v("MIN")]),
        ]),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "bid-time-spot" }, [_vm._v(":")]),
      _vm._v(" "),
      _c("div", { staticClass: "bid-time-sec spaceCenter" }, [
        _c("div", { staticClass: "bid-time-text" }, [
          _c("div", { staticClass: "bid-time-text-big" }, [
            _vm._v(_vm._s(_vm.PrefixInteger(_vm.ss))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bid-time-text-sm" }, [_vm._v("SEC")]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    !_vm.needHideTips
      ? _c("div", { staticClass: "place-text-2" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.hasBid
                  ? "You have already bid on this lot."
                  : "You haven't bid on this lot yet."
              ) +
              "\n  "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }